
import { trigger, state, style, animate, transition } from '@angular/animations';

export const scaleIn = trigger('scaleIn', [
    transition('void => *', [
        style({ transform: 'scale(1.2)', opacity: 0 }),
        animate('.45s cubic-bezier(.3,.01,.27,.99)', style({ transform: 'scale(1)', opacity: 1 })),
    ]),
    transition('* => void', [
        style({ transform: 'scale(1)', opacity: 1 }),
        animate('.3s cubic-bezier(.3,.01,.27,.99)', style({ transform: 'scale(.8)', opacity: 0 })),
    ])
]);
